import React, { useState } from 'react';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { formatFollowers } from '../../utils';
import { CATEGORIES, GENDERS } from '../../constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import FormattedCurrency from '../../components/FormattedCurrency';
import WishList from './WishList';
import Requests from './Requests';
import Deliverables from './Deliverables';


const Container = ({ data, refreshListing }) => {
  console.log("data", data);

  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(1);

  const hasPreviousRoute = location.key !== 'default';

  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <>
      {/* <div className='container'>
    {hasPreviousRoute && (
          <button
            onClick={handleGoBack}
            className="mb-4 text-primary font-semibold text-xl group pt-2 hover:text-secondary flex items-center gap-3"
          >
            <div className='w-10 h-10 bg-primary rounded-full group-hover:bg-secondary flex items-center justify-center'><FaArrowLeft className='text-white'/></div>
            <FormattedMessage id="back" defaultMessage="Back" />
          </button>
        )}
    </div> */}
      <div className="container p-6 bg-white border rounded-lg shadow-lg relative">

        <div className='absolute top-5 right-5'>
          <WishList id={data.id} isWishlisted={data.whislist} />
        </div>
        {/* Profile Section */}
        <div className="flex flex-col md:flex-row items-center md:items-start space-x-6">
          {/* Profile Image */}
          <div
            className=" rounded-xl mb-6 md:mb-0 w-[270px] h-[250px] bg-cover bg-center bg-no-repeat "
            style={{ backgroundImage: `url(${data?.user?.picture || '/images/avatar.png'})` }}
          >
          </div>

          {/* Details and Platforms */}
          <div className="flex-1">
            <div className="mb-6">
              <h1 className="text-3xl font-extrabold text-gray-800 flex items-center flex-wrap gap-x-2">
                <span>{data.user.name} {data.user.sur_name} </span> <span className="text-gray-500 text-xl"> ({data.user.city}{data.user.country ? `, ${data.user.country}` : ""})</span>
              </h1>
              <p className="text-gray-600">{data.user.email}</p>
              <div className="mt-2 flex flex-wrap gap-2">
                {data.niches.map((niche, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-primary text-white rounded-full text-sm font-medium"
                  >
                    {CATEGORIES.find(item => item.value === niche)?.label ? CATEGORIES.find(item => item.value === niche)?.label : niche}
                  </span>
                ))}
              </div>
              <div className="mt-4">
                <p className="text-gray-600">
                  <strong><FormattedMessage id="gender" defaultMessage={"Gender"} />:</strong> {GENDERS.find(item => item.value === data.gender)?.label || "-"}
                </p>
                <p className="text-gray-600">
                  <strong><FormattedMessage id="average_price" defaultMessage={"Average Price"} />:</strong> <FormattedCurrency value={data?.average_price} />
                </p>
              </div>
            </div>

            {/* Platform Stats */}
            {/* <h2 className="text-2xl font-semibold text-gray-800 mb-4">Platforms</h2> */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {data.instagram_name && (
                <div className="p-4 sm:p-4 border rounded-lg shadow-sm flex flex-col sm:flex-row sm:items-center sm:gap-x-4 gap-y-3 bg-gray-50">
                  <FaInstagram className="text-pink-500" size={40} />
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800"><FormattedMessage id="instagram" defaultMessage="Instagram" /></h3>
                    <a
                      href={`https://www.instagram.com/${data.instagram_name}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline text-sm"
                    >
                      {data.instagram_name}
                    </a>
                    <p className="text-sm text-gray-600 mt-1">
                      <strong><FormattedMessage id="followers" defaultMessage="Followers" />:</strong> {formatFollowers(data.instagram_followers)}
                    </p>
                    <p className="text-sm text-gray-600">
                      <strong><FormattedMessage id="engagement_rate" defaultMessage="Engagement Rate" />: </strong> {data.instagram_engagement_metrics}%
                    </p>
                    <p className="text-sm text-gray-600">
                      <strong><FormattedMessage id="bio" defaultMessage="Bio" />: </strong> {data.instagram_bio}
                    </p>
                  </div>
                </div>
              )}

              {data.tiktok_name && (
                <div className="p-4 sm:p-4 border rounded-lg shadow-sm flex flex-col sm:flex-row sm:items-center sm:gap-x-4 gap-y-3 bg-gray-50">
                  <FaTiktok className="text-black" size={40} />
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800"><FormattedMessage id="tiktok" defaultMessage="TikTok" /></h3>
                    <a
                      href={`https://www.tiktok.com/@${data.tiktok_name}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline text-sm"
                    >
                      {data.tiktok_name}
                    </a>
                    <p className="text-sm text-gray-600 mt-1">
                      <strong><FormattedMessage id="followers" defaultMessage="Followers" />:</strong> {formatFollowers(data.tiktok_followers)}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className='font-bold'><FormattedMessage id="engagement_rate" defaultMessage="Engagement Rate" />:</span>
                      {data.tiktok_engagement_metrics}%
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>



        {/* Recent Campaigns */}
        {/* <h2 className="text-2xl font-semibold text-gray-800 mt-10">Recent Campaigns</h2> */}
        {/* <div className="space-y-4 mt-4">
      {data?.recentCampaigns?.length > 0 ? (
        data.recentCampaigns.map((campaign, index) => (
          <div
            key={index}
            className="p-4 rounded-lg shadow-lg border bg-gray-50 hover:shadow-md transition"
          >
            <h3 className="text-lg font-semibold text-gray-800">{campaign.title}</h3>
            <p className="text-gray-600 text-sm">{campaign.description}</p>
            <p className="text-gray-500 text-xs mt-1">
              Date: {new Date(campaign.date).toLocaleDateString()}
            </p>
          </div>
        ))
      ) : (
        <div className="p-4 rounded-lg bg-gray-50 text-center">
          <h3 className="text-md text-gray-800">No recent campaigns</h3>
        </div>
      )}
    </div> */}
      </div>
      <div>
      {
        data?.is_agency_influencer &&
        <div className=" flex container ">
        <div className='my-4'>

        <button
            className={`px-4 py-2 font-semibold ${activeTab === 1 ? 'text-primary border-b-2 border-primary' : 'text-gray-500'}`}
            onClick={() => setActiveTab(1)}
          >
            <FormattedMessage id="requests" defaultMessage={"Requests"} />
          </button>
          <button
            className={`px-4 py-2 font-semibold ${activeTab === 2 ? 'text-primary border-b-2 border-primary' : 'text-gray-500'}`}
            onClick={() => setActiveTab(2)}
          >
            <FormattedMessage id="deliverables" defaultMessage={"Deliverables"} />

          </button>
          
        </div>
        {/* <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="lg:hidden fixed right-4 top-4 z-50 p-2 bg-primary text-white rounded-lg"
          >
            {isSidebarOpen ? "Close" : "Open"}
          </button> */}

      </div>}

      {data?.is_agency_influencer && activeTab === 1 ?
        <div>
          <div className="bg-content-bg rounded-lg shadow-md p-6 mb-10 container">
            <Requests id={data.id} />
          </div>
        </div>
        : data?.is_agency_influencer && activeTab === 2 ?
          <div className="bg-content-bg rounded-lg shadow-md p-6 mb-10 container">

            <Deliverables id={data.id} agencyInfluencerProfile={data} />
          </div>
          : null}


      </div>

    </>
  );
}

export default Container;